import { cloneElement, ReactElement } from 'react';
import { TagLike } from './TagLike';

/**
 * @returns a component which wraps an SVG element and forwards all props to it
 */
export const wrapSvg = (template: ReactElement): TagLike<'svg'> => props =>
  cloneElement(template, props);
